import React, { useState, useEffect } from "react";
import SSPCommonModal from "../../CommonComponents/SSPCommonModal/SSPCommonModal";
import { PageBar, SSPCommonButton } from "../../CommonComponents";
import Grid from "@mui/material/Grid";
import {
    Box,
    Card,
    CardContent,
    Typography,
    TextField,
    Tabs,
    Tab,
    Autocomplete,
    CardHeader,
    Button,
    Divider,
    MenuItem,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { post } from "../../services";
import Cookies from "js-cookie";
import styles from "./Styles";
import Loader from "../../CommonComponents/Loader";
import { FaMoneyBillWave, FaExclamationTriangle, FaFileInvoice } from "react-icons/fa";
import styled from "styled-components";

const base = "https://";
// const apiHost = "dto63rh5ue.execute-api.ap-south-1.amazonaws.com/ssp_dev/ds_reports";
const apiHost = "api.more.in/v1/ds_reports"

const StyledDatePicker = styled(DatePicker)`
  width: 100%; 
  height: 50px;
  border: 1px solid #000;
  border-radius: 4px;
  padding: 8px;
  font-size: 14px;
  color: #333;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  box-sizing: border-box;

  &::placeholder {
    color: #666;
    opacity: 1;
  }
`;

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`report-tabpanel-${index}`}
            aria-labelledby={`report-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

const formatDateForAPI = (date) => {
    if (!date) return "";
    try {
        if (date instanceof Date && !isNaN(date)) {
            return date.toISOString().split("T")[0];
        } return "";
    } catch (e) { console.error("Error formatting date:", e); return ""; }
};

// const parseCurrency = (value) => {
//     if (typeof value !== 'string') return NaN;
//     const numberString = value.replace(/[^0-9.-]+/g, "");
//     const parsed = parseFloat(numberString);
//     return isNaN(parsed) ? NaN : parsed;
// }
const parseCurrency = (value) => {
    // Check for null/undefined first
    if (value === null || value === undefined) return NaN;

    // Convert the incoming value (which could be a number or string) to a string
    const stringValue = String(value);

    // Now the rest of your original function will work perfectly
    const numberString = stringValue.replace(/[^0-9.-]+/g, "");
    const parsed = parseFloat(numberString);
    return isNaN(parsed) ? NaN : parsed;
}
const DSReport = ({ token }) => {

    const ssp_loc = Cookies.get("ssp_loc");
    const [loading, setLoading] = useState(false);
    const [modalOpener, setmodalOpener] = useState(false);
    const [message, setmessage] = useState("");
    const [transactionType, setTransactionType] = useState("");

    const [activeTab, setActiveTab] = useState(0);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    // --- Filter Options ---
    const [cashierList, setCashierList] = useState([]);
    const [posIdList, setPosIdList] = useState([]);
    const [divisionList, setDivisionList] = useState([]);
    const [departmentList, setDepartmentList] = useState([]);
    // --- Selected Filter Values ---
    const [selectedCashiers, setSelectedCashiers] = useState([]);
    const [selectedPosIds, setSelectedPosIds] = useState([]);
    const [selectedDivisions, setSelectedDivisions] = useState([]);
    const [selectedDepartments, setSelectedDepartments] = useState([]);
    // --- Date States ---
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [recoDate, setRecoDate] = useState(new Date());
    // --- Reconciliation States ---
    const [totalSales, setTotalSales] = useState("");
    const [toCollect, setToCollect] = useState("");
    const [recoData, setRecoData] = useState([]);
    const collectAmount = parseCurrency(toCollect);
    const totalSalesAmount = parseCurrency(totalSales);


    const recoColumns = [
        { field: 'cashier', headerName: 'Cashier', headerAlign: 'center', align: 'center', width: isMobile ? 120 : 213, },
        { field: 'tender_name', headerName: 'Tender Name', headerAlign: 'center', align: 'center', width: isMobile ? 150 : 213, },
        { field: 'transaction_amount', headerName: 'Transaction Amount', headerAlign: 'center', align: 'center', width: isMobile ? 180 : 213, valueFormatter: (params) => typeof params.value === 'number' ? params.value.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : params.value },
        { field: 'acceptable_difference', headerName: 'Acceptable Difference', headerAlign: 'center', align: 'center', width: isMobile ? 180 : 213, valueFormatter: (params) => typeof params.value === 'number' ? params.value.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : params.value },
        { field: 'actual_difference', headerName: 'Actual Difference', headerAlign: 'center', align: 'center', width: isMobile ? 180 : 213, valueFormatter: (params) => typeof params.value === 'number' ? params.value.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : params.value },
        { field: 'difference', headerName: 'Difference', headerAlign: 'center', align: 'center', width: isMobile ? 120 : 213, valueFormatter: (params) => typeof params.value === 'number' ? params.value.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : params.value },
    ];

    useEffect(() => {
        getCashierPosId();
        getDivisions();
    }, []);

    const getCashierPosId = async () => {
        setLoading(true);
        let response = await post(`${base}${apiHost}/get_cashier_pos_id`, { "location_code": ssp_loc }, true, false);
        if (response?.body?.status === "success") {
            const cashiers = response.body.data.cashier.map(c => ({ id: c, name: c }));
            const posIds = response.body.data.pos_id.map(p => ({ id: p, name: p }));
            setCashierList([{ id: "all", name: "All" }, ...cashiers]);
            setPosIdList([{ id: "all", name: "All" }, ...posIds]);
        } else {
            setmessage(response?.body?.message || "Failed fetch cashier/POS"); setmodalOpener(true);
        }
        setLoading(false);
    };

    const getDivisions = async () => {
        setLoading(true);
        let response = await post(`${base}${apiHost}/get_division`, { "location_code": ssp_loc }, true, false);
        if (response?.body?.status === "success") {
            setDivisionList([{ division: "all", division_name: "All" }, ...response.body.data]);
        } else {
            setmessage(response?.body?.message || "Failed fetch divisions"); setmodalOpener(true);
        }
        setLoading(false);
    };

    useEffect(() => {
        if (selectedDivisions.length === 0) {
            setDepartmentList([]); setSelectedDepartments([]); return;
        }
        const isAllSelected = selectedDivisions.some(d => d.division === 'all');
        const divisionIds = selectedDivisions.map(d => d.division).filter(id => id !== "all");

        if (!isAllSelected && divisionIds.length > 0) {
            getDepartments(divisionIds);
        } else if (selectedDivisions[0].division === 'all') {
            getDepartments([selectedDivisions[0]?.division]);
        }
        else {
            setDepartmentList([]); setSelectedDepartments([]);
        }
    }, [selectedDivisions]);

    const getDepartments = async (divisionIds) => {
        setLoading(true);
        let response = await post(`${base}${apiHost}/get_department`, { "location_code": ssp_loc, "divisions": divisionIds }, true, false);
        if (response?.body?.status === "success") {
            setDepartmentList([{ dept: "all", dept_name: "All" }, ...response.body.data]);
            setSelectedDepartments([]);
        } else {
            setDepartmentList([]); setSelectedDepartments([]);
            setmessage(response?.body?.message || "Failed fetch departments"); setmodalOpener(true);
        }
        setLoading(false);
    };

    useEffect(() => {
        if (activeTab === 2 && recoDate && selectedCashiers.length > 0 && selectedPosIds.length > 0) {
            fetchTotalSales();
        } else if (activeTab === 2) {
            setTotalSales(""); setToCollect("");
        }
    }, [activeTab, selectedCashiers, selectedPosIds, recoDate]);

    const fetchTotalSales = async () => {
        if (!recoDate || selectedCashiers.length === 0 || selectedPosIds.length === 0) return;
        setLoading(true);
        const cashiersPayload = selectedCashiers.some(c => c.id === 'all') ? ['all'] : selectedCashiers.map(c => c.id);
        const posIdsPayload = selectedPosIds.some(p => p.id === 'all') ? ['all'] : selectedPosIds.map(p => p.id);
        const payload = { cashiers: cashiersPayload, pos_ids: posIdsPayload, reco_date: formatDateForAPI(recoDate), location_code: ssp_loc };
        try {
            let response = await post(`${base}${apiHost}/get_total_sales`, payload, true, false);
            if (response?.body?.status === "success" && response.body.data?.total_sales !== undefined) {
                const salesValue = response.body.data.total_sales;
                setTotalSales(salesValue);
                const numericSales = parseCurrency(salesValue);
                // setToCollect(!isNaN(numericSales) ? numericSales.toFixed(2) : ""); // Set To Collect
            } else {
                setTotalSales(""); setToCollect("");
                setmessage(response?.body?.message || "Failed fetch total sales"); setmodalOpener(true);
            }
        } catch (error) { console.error("Err fetch total sales:", error); setTotalSales(""); setToCollect(""); setmessage("Err occurred fetching sales."); setmodalOpener(true); }
        finally { setLoading(false); }
    };

    const handleDownloadReport = async () => {
        let validationError = "";
        const isDivisionAll = selectedDivisions.some(d => d.division === 'all');
        const isCashierAll = selectedCashiers.some(c => c.id === 'all');
        const isPosAll = selectedPosIds.some(p => p.id === 'all');
        if (activeTab === 0 && !transactionType) validationError = "Please select Transaction Type.";
        else if (selectedCashiers.length === 0) validationError = "Please select Cashier ID.";
        else if (selectedPosIds.length === 0) validationError = "Please select POS ID.";
        else if (activeTab === 0 && selectedDivisions.length === 0) validationError = "Please select Division.";
        else if (activeTab === 0 && isDivisionAll && selectedDepartments.length === 0) {
            validationError = "Please select Department.";
        }
        else if (activeTab === 0 && selectedDivisions.length > 0 && !isDivisionAll && selectedDepartments.length === 0) {
            validationError = "Please select Department.";
        }
        else if (!startDate) validationError = "Please select Start Date.";
        else if (!endDate) validationError = "Please select End Date.";

        if (validationError) { setmessage(validationError); setmodalOpener(true); return; }

        setLoading(true);
        const report_type = activeTab === 0 ? "transaction_report" : "void_report";
        const cashiersPayload = selectedCashiers.length === 0 ? ['all'] : selectedCashiers.some(c => c.id === 'all') ? ['all'] : selectedCashiers.map(c => c.id);
        const posIdsPayload = selectedPosIds.length === 0 ? ['all'] : selectedPosIds.some(p => p.id === 'all') ? ['all'] : selectedPosIds.map(p => p.id);
        const divisionsPayload = selectedDivisions.length === 0 ? ['all'] : selectedDivisions.some(d => d.division === 'all') ? ['all'] : selectedDivisions.map(d => d.division);
        const departmentPayload = selectedDepartments.length === 0 ? ['all'] : selectedDepartments.some(d => d.dept === 'all') ? ['all'] : selectedDepartments.map(d => d.dept);

        const payload = {
            cashiers: cashiersPayload, pos_ids: posIdsPayload,
            start_date: formatDateForAPI(startDate), end_date: formatDateForAPI(endDate),
            location_code: ssp_loc, report_type: report_type,
            transaction_type: activeTab === 0 ? transactionType : '',
        };
        if (activeTab === 0) { payload.divisions = divisionsPayload; payload.departments = departmentPayload; }
        else if (activeTab === 1) { payload.divisions = []; payload.departments = []; }

        try {
            let response = await post(`${base}${apiHost}/download_reports`, payload, true, false);
            if (response?.body?.status === "success" && response.body.data) { window.open(response.body.data, "_blank"); }
            else { setmessage(response?.body?.message || "Failed generate report link."); setmodalOpener(true); }
        } catch (error) { console.error("Err downloading report:", error); setmessage("Err downloading report."); setmodalOpener(true); }
        finally { setLoading(false); }
    };

    const handleGenerateReco = async () => {
        console.log('total sales condition=', Number(totalSalesAmount) === 0, 'total sales amount=', Number(totalSalesAmount), 'totalSalesAmount==', totalSalesAmount)
        let validationError = "";
        // const collectAmount = parseCurrency(toCollect);
        // const totalSalesAmount = parseCurrency(totalSales);
        if (selectedCashiers.length === 0) validationError = "Please select Cashier ID.";
        else if (selectedPosIds.length === 0) validationError = "Please select POS ID.";
        else if (!recoDate) validationError = "Please select Reco Date.";
        else if (totalSales === '' || isNaN(totalSalesAmount)) validationError = "Please enter Total Sales.";
        else if (Number(totalSalesAmount) === 0) validationError = "Report cannot be generated because the Total Sales amount is 0.";
        else if (toCollect === "" || isNaN(collectAmount)) validationError = "Please enter valid amount for To Collect.";

        if (validationError) { setmessage(validationError); setmodalOpener(true); return; }

        setLoading(true); setRecoData([]);
        const cashiersPayload = selectedCashiers.length === 0 ? ['all'] : selectedCashiers.some(c => c.id === 'all') ? ['all'] : selectedCashiers.map(c => c.id);
        const posIdsPayload = selectedPosIds.length === 0 ? ['all'] : selectedPosIds.some(p => p.id === 'all') ? ['all'] : selectedPosIds.map(p => p.id);
        const payload = { cashiers: cashiersPayload, pos_ids: posIdsPayload, reco_date: formatDateForAPI(recoDate), amount: collectAmount, location_code: ssp_loc, };

        try {
            let response = await post(`${base}${apiHost}/get_reco_data`, payload, true, false);
            if (response?.body?.status === "success") {
                const rowsWithId = (response.body.data || []).map((row, index) => ({ ...row, id: index }));
                setRecoData(rowsWithId);
                if (response?.body?.message && rowsWithId.length === 0) { setmessage(response.body.message); setmodalOpener(true); }
                else if (rowsWithId.length === 0) { setmessage("No reconciliation data found."); setmodalOpener(true); }
            } else { setmessage(response?.body?.message || "Failed generate data."); setmodalOpener(true); }
        } catch (error) { console.error("Err generating reconciliation:", error); setmessage("Err generating reconciliation."); setmodalOpener(true); }
        finally { setLoading(false); }
    };

    const resetFilters = () => {
        setSelectedCashiers([]); setSelectedPosIds([]); setSelectedDivisions([]); setSelectedDepartments([]);
        setDepartmentList([]);
        setTransactionType("");
        setStartDate(new Date()); setEndDate(new Date()); setRecoDate(new Date());
        setTotalSales(""); setToCollect(""); setRecoData([]);
    };

    const handleTabChange = (event, newValue) => { setActiveTab(newValue); resetFilters(); };

    const createAutocompleteHandler = (setter, list) => (event, newValue) => {
        if (!list || list.length === 0) { setter([]); return; }
        const allOption = list.find(opt => opt.id === 'all' || opt.division === 'all');
        if (newValue.length === 0) { setter([]); return; }
        const lastSelected = newValue[newValue.length - 1];
        const lastClickedAll = allOption && lastSelected === allOption;
        if (lastClickedAll) { setter([allOption]); return; }
        const newSelection = newValue.filter(opt => opt !== allOption);
        setter(newSelection);
    };

    const createDeptAutocompleteHandler = (setter, list) => (event, newValue) => {
        if (!list || list.length === 0) { setter([]); return; }
        const allOption = list.find(opt => opt.dept === 'all');
        if (newValue.length === 0) { setter([]); return; }
        const lastSelected = newValue[newValue.length - 1];
        const lastClickedAll = allOption && lastSelected === allOption;
        if (lastClickedAll) { setter([allOption]); return; }
        const newSelection = newValue.filter(option => option !== allOption);
        setter(newSelection);
    };

    return (
        <Box sx={styles.background}>
            <Loader loading={loading} />
            <PageBar text="DarkSaber : Reports" />

            <Card sx={{ m: 2, borderRadius: 2, boxShadow: 3 }}>
                <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <Tabs value={activeTab} onChange={handleTabChange} aria-label="report tabs"
                            variant="scrollable"
                            scrollButtons="auto"
                            allowScrollButtonsMobile
                        >
                            <Tab icon={<FaMoneyBillWave />} iconPosition="start" label="Transactions Report" />
                            <Tab icon={<FaExclamationTriangle />} iconPosition="start" label="Void/Hold Report" />
                            <Tab icon={<FaFileInvoice />} iconPosition="start" label="Reconciliation" />
                        </Tabs>
                    </Box>
                    {/* Tab 1 */}
                    <TabPanel value={activeTab} index={0}>
                        <Grid container spacing={3} alignItems="flex-start">

                            <Grid item xs={12} sm={6} md={3}>
                                <Typography variant="subtitle2" gutterBottom>Transaction Type:</Typography>
                                <TextField
                                    select
                                    placeholder="Select Type"
                                    value={transactionType}
                                    onChange={(e) => setTransactionType(e.target.value)}
                                    size="small" // <-- Ensure this is present
                                    fullWidth
                                    displayEmpty
                                    sx={{
                                        height: '50px',
                                        '& .MuiInputBase-root': {
                                            height: '100%',
                                        },
                                        '& .MuiSelect-select': {

                                            display: 'flex',
                                            alignItems: 'center',
                                            height: '100%',
                                            paddingTop: 0,
                                            paddingBottom: 0,
                                            boxSizing: 'border-box'
                                        },

                                        backgroundColor: '#fff',
                                    }}
                                >
                                    {/* <MenuItem value="" disabled><em>Select Type</em></MenuItem> */}
                                    <MenuItem value="Sales">Sales</MenuItem>
                                    <MenuItem value="Wallet">Wallet</MenuItem>
                                </TextField>
                            </Grid>

                            <Grid item xs={12} sm={6} md={3}>
                                <Typography variant="subtitle2" gutterBottom>Cashier Id :</Typography>
                                <Autocomplete
                                    multiple limitTags={1} options={cashierList} getOptionLabel={(option) => option?.name || ""}
                                    value={selectedCashiers} onChange={createAutocompleteHandler(setSelectedCashiers, cashierList)} disableCloseOnSelect
                                    renderInput={(params) => <TextField {...params} variant="outlined" size="small"
                                        placeholder={selectedCashiers.length === 0 ? "Select Cashier(s)" : ""}
                                    />}
                                    sx={styles.autocompleteField}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Typography variant="subtitle2" gutterBottom>POS Id :</Typography>
                                <Autocomplete
                                    multiple limitTags={1} options={posIdList} getOptionLabel={(option) => option?.name || ""}
                                    value={selectedPosIds} onChange={createAutocompleteHandler(setSelectedPosIds, posIdList)} disableCloseOnSelect
                                    renderInput={(params) => <TextField {...params} variant="outlined" size="small"
                                        placeholder={selectedPosIds.length === 0 ? "Select POS ID(s)" : ""}
                                    />}
                                    sx={styles.autocompleteField}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Typography variant="subtitle2" gutterBottom>Division :</Typography>
                                <Autocomplete
                                    multiple limitTags={1} options={divisionList} getOptionLabel={(option) => option?.division_name || ""}
                                    value={selectedDivisions} onChange={createAutocompleteHandler(setSelectedDivisions, divisionList)} disableCloseOnSelect
                                    renderInput={(params) => <TextField {...params} variant="outlined" size="small"
                                        placeholder={selectedDivisions.length === 0 ? "Select Division(s)" : ""}
                                    />}
                                    sx={styles.autocompleteField}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Typography variant="subtitle2" gutterBottom>Department :</Typography>
                                <Autocomplete
                                    multiple limitTags={1} options={departmentList} getOptionLabel={(option) => option?.dept_name || ""}
                                    value={selectedDepartments} onChange={createDeptAutocompleteHandler(setSelectedDepartments, departmentList)} disableCloseOnSelect
                                    renderInput={(params) => <TextField {...params} variant="outlined" size="small"
                                        placeholder={selectedDivisions.length === 0 ? "Select Division first" : selectedDepartments.length === 0 ? "Select Department(s)" : ""}
                                    />}
                                    disabled={selectedDivisions.length === 0}
                                    sx={styles.autocompleteField}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Typography variant="subtitle2" gutterBottom>* Period</Typography>
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                    <StyledDatePicker selected={startDate} onChange={(date) => setStartDate(date)} placeholderText="Start Date" dateFormat="yyyy-MM-dd" isClearable maxDate={endDate || new Date()} />
                                    <StyledDatePicker selected={endDate} onChange={(date) => setEndDate(date)} placeholderText="End Date" dateFormat="yyyy-MM-dd" minDate={startDate} maxDate={new Date()} isClearable disabled={!startDate} />
                                </Box>
                            </Grid>
                            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', pt: { xs: 0, md: 3 } }}>
                                <SSPCommonButton btnText="Download Report" btnFunction={handleDownloadReport} />
                            </Grid>
                        </Grid>
                    </TabPanel>
                    {/* Tab 2*/}
                    <TabPanel value={activeTab} index={1}>
                        <Grid container spacing={3} alignItems="flex-start">
                            {/* Cashier ID */}
                            <Grid item xs={12} sm={6} md={3}>
                                <Typography variant="subtitle2" gutterBottom>Cashier Id :</Typography>
                                <Autocomplete
                                    multiple limitTags={1} options={cashierList} getOptionLabel={(option) => option?.name || ""}
                                    value={selectedCashiers} onChange={createAutocompleteHandler(setSelectedCashiers, cashierList)} disableCloseOnSelect
                                    renderInput={(params) => <TextField {...params} variant="outlined" size="small"
                                        placeholder={selectedCashiers.length === 0 ? "Select Cashier(s)" : ""}
                                    />}
                                    sx={styles.autocompleteField}
                                />
                            </Grid>
                            {/* POS ID */}
                            <Grid item xs={12} sm={6} md={3}>
                                <Typography variant="subtitle2" gutterBottom>POS Id :</Typography>
                                <Autocomplete
                                    multiple limitTags={1} options={posIdList} getOptionLabel={(option) => option?.name || ""}
                                    value={selectedPosIds} onChange={createAutocompleteHandler(setSelectedPosIds, posIdList)} disableCloseOnSelect
                                    renderInput={(params) => <TextField {...params} variant="outlined" size="small"
                                        placeholder={selectedPosIds.length === 0 ? "Select POS ID(s)" : ""}
                                    />}
                                    sx={styles.autocompleteField}
                                />
                            </Grid>
                            {/* Period */}
                            <Grid item xs={12} sm={6} md={3}>
                                <Typography variant="subtitle2" gutterBottom>* Period</Typography>
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                    <StyledDatePicker selected={startDate} onChange={(date) => setStartDate(date)} placeholderText="Start Date" dateFormat="yyyy-MM-dd" isClearable maxDate={endDate || new Date()} />
                                    <StyledDatePicker selected={endDate} onChange={(date) => setEndDate(date)} placeholderText="End Date" dateFormat="yyyy-MM-dd" minDate={startDate} maxDate={new Date()} isClearable disabled={!startDate} />
                                </Box>
                            </Grid>
                            {/* Download Button */}
                            {/* <Grid item xs={12} md={3} sx={styles.buttonGrid}> */}
                            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', pt: { xs: 0, md: 3 } }}>
                                <SSPCommonButton btnText="Download Report" btnFunction={handleDownloadReport} />
                            </Grid>
                        </Grid>
                    </TabPanel>

                    {/* Tab 3: Reconciliation */}
                    <TabPanel value={activeTab} index={2}>
                        <Grid container spacing={3} alignItems="flex-start">
                            {/* Cashier ID */}
                            <Grid item xs={12} sm={6} md={3}>
                                <Typography variant="subtitle2" gutterBottom>Cashier Id :</Typography>
                                <Autocomplete
                                    multiple limitTags={1} options={cashierList} getOptionLabel={(option) => option?.name || ""}
                                    value={selectedCashiers} onChange={createAutocompleteHandler(setSelectedCashiers, cashierList)} disableCloseOnSelect
                                    renderInput={(params) => <TextField {...params} variant="outlined" size="small"
                                        placeholder={selectedCashiers.length === 0 ? "Select Cashier(s)" : ""}
                                    />}
                                    sx={styles.autocompleteField}
                                />
                            </Grid>
                            {/* POS ID */}
                            <Grid item xs={12} sm={6} md={3}>
                                <Typography variant="subtitle2" gutterBottom>POS Id :</Typography>
                                <Autocomplete
                                    multiple limitTags={1} options={posIdList} getOptionLabel={(option) => option?.name || ""}
                                    value={selectedPosIds} onChange={createAutocompleteHandler(setSelectedPosIds, posIdList)} disableCloseOnSelect
                                    renderInput={(params) => <TextField {...params} variant="outlined" size="small"
                                        placeholder={selectedPosIds.length === 0 ? "Select POS ID(s)" : ""}
                                    />}
                                    sx={styles.autocompleteField}
                                />
                            </Grid>
                            {/* Reco Date */}
                            <Grid item xs={12} sm={6} md={2}>
                                <Typography variant="subtitle2" gutterBottom>* Reco Date</Typography>
                                <StyledDatePicker selected={recoDate} onChange={(date) => setRecoDate(date)} placeholderText="Reco Date" dateFormat="yyyy-MM-dd" isClearable maxDate={new Date()} />
                            </Grid>
                            {/* Total Sales */}
                            <Grid item xs={12} sm={6} md={2}>
                                <Typography variant="subtitle2" gutterBottom>* Total Sales</Typography>
                                <TextField value={totalSales}
                                    disabled
                                    fullWidth
                                    sx={styles.totalSalesField}
                                />
                            </Grid>
                            {/* To Collect */}
                            <Grid item xs={12} sm={6} md={2}>
                                <Typography variant="subtitle2" gutterBottom>* To Collect</Typography>
                                <TextField value={toCollect} onChange={(e) => setToCollect(e.target.value)} type="number" fullWidth sx={styles.toCollectField} InputProps={{ sx: { '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': { '-webkit-appearance': 'none', margin: 0, }, '& input[type=number]': { '-moz-appearance': 'textfield', }, }, }} />
                            </Grid>

                            {/* Generate Button */}
                            <Grid item xs={12} sx={styles.buttonGrid}>
                                <SSPCommonButton btnText="Generate Report"
                                    disabled
                                    // disabled={totalSales === '' || isNaN(totalSalesAmount) || toCollect === "" || isNaN(collectAmount)}
                                    btnFunction={() => { handleGenerateReco() }}

                                />
                            </Grid>


                        </Grid>

                        {/* Reconciliation DataGrid */}
                        {recoData?.length > 0 && (
                            <>
                                {/* Removed Card/CardHeader around DataGrid for cleaner look */}
                                <Divider sx={{ my: 3 }} /> {/* Added Divider */}
                                <Typography variant="h6" gutterBottom sx={{ color: "#0160F1", fontWeight: 600 }}>
                                    Reconciliation Details
                                </Typography>
                                <Box sx={styles.dataGridBox}>
                                    <DataGrid
                                        density="compact" showCellVerticalBorder={true} showColumnVerticalBorder={true}
                                        // sx={styles.dataGridStyling}
                                        sx={{
                                            ".MuiDataGrid-columnHeaderTitle": { fontWeight: "bold !important", fontSize: isMobile ? "0.8rem" : "0.9rem", whiteSpace: 'normal', lineHeight: 1.3, },
                                            ".MuiDataGrid-cell": { fontSize: isMobile ? "0.7rem" : "0.85rem", padding: isMobile ? "4px" : "8px", lineHeight: 1.4, },
                                            ".MuiDataGrid-columnHeaders": { backgroundColor: '#f4f4f4', borderBottom: '1px solid #ccc' },
                                            ".MuiDataGrid-toolbarContainer button": { color: '#0160F1' },
                                            overflowX: "auto",
                                        }}
                                        rows={recoData} columns={recoColumns}
                                        initialState={{ pagination: { paginationModel: { pageSize: 10, }, }, }}
                                        pageSizeOptions={[10, 25, 50]} getRowId={(row) => row.id}
                                        components={{ Toolbar: GridToolbar, }}
                                        componentsProps={{ toolbar: { showQuickFilter: true, quickFilterProps: { debounceMs: 500 }, csvOptions: { allColumns: true }, printOptions: { disableToolbarButton: true } }, }}
                                        disableRowSelectionOnClick
                                    />
                                </Box>
                            </>
                        )}
                    </TabPanel>
                </CardContent>
            </Card>

            {modalOpener && (
                <SSPCommonModal open={modalOpener} handleOpenClose={() => setmodalOpener(false)} message={message} />
            )}
        </Box>
    );
};

export default DSReport;


